import { useFormContext, useWatch } from "react-hook-form";
import { getAccessedPropertyNames } from "src/components/Form/utils/getAccessedPropertyNames.ts";
import type { ValidFormPanel } from "src/components/Form/Form.types.ts";

export const useIsPanelHidden = ({
  panel,
}: {
  panel: ValidFormPanel<any, any>;
}) => {
  const { control, getValues } = useFormContext<any>();

  const names = getHiddenPanelNames({
    panel,
    values: getValues(),
  });

  useWatch({
    // @ts-ignore
    name: names,
    disabled: !names,
    control,
  });

  return {
    isHidden: panel.hidden
      ? typeof panel.hidden === "function"
        ? panel.hidden(getValues())
        : typeof panel.hidden === "boolean"
        ? panel.hidden
        : panel.hidden.hide_condition(getValues())
      : false,
  };
};

const getHiddenPanelNames = ({
  panel,
  values,
}: {
  panel: ValidFormPanel<any, any>;
  values: any;
}) => {
  if (!panel.hidden) {
    return undefined;
  }
  if (typeof panel.hidden === "function") {
    return getAccessedPropertyNames({
      object: values,
      callback: panel.hidden,
    });
  }
  if (typeof panel.hidden === "boolean") {
    return [];
  }
  if (panel.hidden?.watch_names) {
    return panel.hidden?.watch_names;
  }

  return getAccessedPropertyNames({
    object: values,
    callback: panel.hidden.hide_condition,
  });
};
